import { useEffect, useState } from 'react';

const useOnce = (callback: () => void) => {
  const [called, setCalled] = useState(false);
  useEffect(() => {
    setCalled(true);
  }, []);
  useEffect(() => {
    if (called) {
      callback();
    }
  }, [called, callback]);
};

export default useOnce;
